// Public lesson pages are served from a different hostname than the Hub:
// learning.petcademy.org (the subdomain taken over from Gamma) and
// app.petcademy.org are Netlify domain aliases on one site, so both serve
// /lesson/* and /hub/*.
//
// That matters for auth. A `?t=` token on a public URL upgrades the reader into a
// Hub session, and the session lives in localStorage, which is per-origin. Handing
// off relatively would create that session on learning.petcademy.org — leaving the
// parent with a second, separate Hub away from the canonical host.
//
// Only the production lessons host needs redirecting. Staging, branch deploys and
// local dev serve both surfaces from one origin, so they stay relative and keep
// working without any environment configuration.
export const LESSONS_HOST = 'learning.petcademy.org';
export const HUB_ORIGIN = 'https://app.petcademy.org';

/**
 * Resolve an in-app path to navigate to for a Hub handoff. Returns the path
 * unchanged when the current origin already serves the Hub, or an absolute URL on
 * the Hub's origin when it does not.
 */
export function hubHandoffTarget(path: string, hostname: string): string {
  return hostname === LESSONS_HOST ? `${HUB_ORIGIN}${path}` : path;
}

/** True when a handoff has to leave the current origin. */
export function isCrossOrigin(target: string): boolean {
  return target.startsWith('http://') || target.startsWith('https://');
}
